module.exports = __webpack_public_path__ + "img/orange_130.6cee94c6.png";